import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  TextField,
  Switch,
  CardContent,
  Button,
  Grid,
  FormControlLabel,
  LinearProgress,
  Box,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers";
import * as yup from "yup";
import { CategoryService } from "../../services/CategoryService";
import { useSelector } from "react-redux";
import MAlert from "../elements/MAlert";
import { createSelector } from "reselect";

const useStyle = makeStyles((theme) => ({
  box: {
    marginTop: theme.spacing(4),
  },
}));

const socketSelector = createSelector(
  (state) => state.socket,
  (socket) => socket,
);
const NewCategory = ({ editItemObj, setItemObj, ...rest }) => {
  const socket = useSelector(socketSelector);
  const classes = useStyle();
  const [progress, setProgress] = React.useState(0);
  const [showProgress, setShowProgress] = React.useState(false);
  const [alert, setAlert] = React.useState({
    show: false,
    message: null,
    type: null,
  });
  const [fTen, setFTen] = useState(true);
  const [feleven, setFEleven] = useState(true);
  const [eElevenByTwo, setEElevenByTwo] = useState(true);
  const [eElevenByThree, setEElevenByThree] = useState(true);
  const [eElevenByFour, setEElevenByFour] = useState(true);
  const [golra, setGolra] = useState(true);
  const [gTharteen, setGTharteen] = useState(true);
  const [dTwelve, setDTwelve] = useState(true);

  const onUploadProgress = (progressEvent) => {
    const { loaded, total } = progressEvent;
    let percent = Math.floor((loaded * 100) / total);
    setProgress(percent);
    if (percent === 100) {
      setTimeout(() => {
        setProgress(0);
        setShowProgress(false);
      }, 1000);
    }
  };

  const CategorySchema = yup.object().shape({
    title: yup
      .string()
      .trim("The category title cannot include leading and trailing spaces ")
      .required(),
    description: yup.string().required(),
    status: yup.boolean(),
    categoryImage: yup.mixed().required("Category image is required"),
  });

  const { register, handleSubmit, setValue, reset, errors } = useForm({
    resolver: yupResolver(CategorySchema),
    defaultValues: { status: true },
  });

  //const [status , setStatus] = React.useState(true)

  useEffect(() => {
    if (editItemObj.isEdit) {
      setValue("title", editItemObj.item?.title, { shouldValidate: true });
      setValue("description", editItemObj.item?.description, {
        shouldValidate: true,
      });
      setFTen(editItemObj.item?.fTen || false);
      setFEleven(editItemObj.item?.feleven || false);
      setEElevenByTwo(editItemObj.item?.eElevenByTwo || false);
      setEElevenByThree(editItemObj.item?.eElevenByThree || false);
      setEElevenByFour(editItemObj.item?.eElevenByFour || false);
      setGolra(editItemObj.item?.golra || false);
      setGTharteen(editItemObj.item?.gTharteen || false);
      setDTwelve(editItemObj.item?.dTwelve || false);
    }
  }, [editItemObj, setValue]);

  const resetForm = () => {
    editItemObj.isEdit = false;
    setShowProgress(false);
    setFTen(false);
    setFEleven(false);
    setEElevenByTwo(false);
    setEElevenByThree(false);
    setEElevenByFour(false);
    setGolra(false);
    setGTharteen(false);
    setDTwelve(false);
    reset(
      {
        title: null,
        description: null,
        categoryImage: null,
      },
      {
        errors: true, // errors will not be reset
        dirtyFields: true, // dirtyFields will not be reset
        isDirty: true, // dirty will not be reset
        isSubmitted: false,
        touched: false,
        isValid: false,
        submitCount: false,
      },
    );
  };

  const onSubmit = (data) => {
    data.categoryImage = data.categoryImage[0];
    data.fTen = fTen;
    data.feleven = feleven;
    data.eElevenByTwo = eElevenByTwo;
    data.eElevenByThree = eElevenByThree;
    data.eElevenByFour = eElevenByFour;
    data.golra = golra;
    data.gTharteen = gTharteen;
    data.dTwelve = dTwelve;
    setShowProgress(true);
    //data.status= status
    if (editItemObj.isEdit) {
      CategoryService.edit(data, editItemObj.item.id)
        .then((res) => {
          socket.emit("EVENT_CATEGORY", res.response);
          setItemObj({ item: res.response, isNew: false });

          resetForm();
          setAlert({
            show: true,
            message: res.message,
            type: "success",
          });
        })
        .catch((error) => {
          setAlert({
            show: true,
            message: "Can't edit category.",
            type: "error",
          });
        });
      return;
    } else {
      CategoryService.save(data, onUploadProgress)
        .then((res) => {
          setItemObj({ item: res.response, isNew: true });
          resetForm();
          setAlert({
            show: true,
            message: res.message,
            type: "success",
          });
        })
        .catch((error) => {
          setAlert({
            show: true,
            message: "Can't insert new category",
            type: "error",
          });
        });
    }
  };
  return (
    <form noValidate onSubmit={handleSubmit(onSubmit)}>
      <Card>
        <MAlert alert={alert} setAlert={setAlert} />
        <CardHeader
          title="New Category"
          action={
            <FormControlLabel
              control={
                <Switch
                  checked
                  name="status"
                  inputRef={register}
                  inputProps={{ name: "status" }}
                />
              }
            />
          }
        />
        <CardContent>
          <TextField
            error={errors.title ? true : false}
            variant="outlined"
            margin="normal"
            inputRef={register}
            required
            fullWidth
            id="title"
            label="Title"
            name="title"
            autoComplete="title"
            helperText={errors.title?.message}
            autoFocus
          />

          <TextField
            multiline
            rows={4}
            error={errors.description ? true : false}
            variant="outlined"
            margin="normal"
            inputRef={register}
            required
            fullWidth
            id="description"
            label="Description"
            name="description"
            autoComplete="description"
            helperText={errors.description?.message}
          />

          <TextField
            type="file"
            error={errors.categoryImage ? true : false}
            variant="outlined"
            margin="normal"
            inputRef={register}
            required
            fullWidth
            id="categoryImage"
            name="categoryImage"
            autoComplete="categoryImage"
            helperText={errors.categoryImage?.message}
          />

          <Grid container spacing={2} style={{ marginTop: 16 }}>
            <Grid item xs={6} sm={3}>
              <FormControlLabel
                control={
                  <Switch
                    checked={fTen}
                    onChange={(e) => setFTen(e.target.checked)}
                    name="fTen"
                  />
                }
                label="F-10"
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <FormControlLabel
                control={
                  <Switch
                    checked={feleven}
                    onChange={(e) => setFEleven(e.target.checked)}
                    name="feleven"
                  />
                }
                label="F-11"
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <FormControlLabel
                control={
                  <Switch
                    checked={eElevenByTwo}
                    onChange={(e) => setEElevenByTwo(e.target.checked)}
                    name="eElevenByTwo"
                  />
                }
                label="E-11/2"
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <FormControlLabel
                control={
                  <Switch
                    checked={eElevenByThree}
                    onChange={(e) => setEElevenByThree(e.target.checked)}
                    name="eElevenByThree"
                  />
                }
                label="E-11/3"
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <FormControlLabel
                control={
                  <Switch
                    checked={eElevenByFour}
                    onChange={(e) => setEElevenByFour(e.target.checked)}
                    name="eElevenByFour"
                  />
                }
                label="E-11/4"
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <FormControlLabel
                control={
                  <Switch
                    checked={golra}
                    onChange={(e) => setGolra(e.target.checked)}
                    name="golra"
                  />
                }
                label="Golra"
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <FormControlLabel
                control={
                  <Switch
                    checked={gTharteen}
                    onChange={(e) => setGTharteen(e.target.checked)}
                    name="gTharteen"
                  />
                }
                label="G-13"
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <FormControlLabel
                control={
                  <Switch
                    checked={dTwelve}
                    onChange={(e) => setDTwelve(e.target.checked)}
                    name="dTwelve"
                  />
                }
                label="D-12"
              />
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Button
                type="reset"
                fullWidth
                variant="contained"
                color="primary"
                onClick={() => resetForm()}
              >
                Clear
              </Button>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
              >
                {editItemObj.isEdit ? "Edit" : "Save"}
              </Button>
            </Grid>
          </Grid>

          <Box
            width="100%"
            className={classes.box}
            mr={1}
            style={{ display: showProgress ? "block" : "none" }}
          >
            <LinearProgress variant="determinate" value={progress} />
          </Box>
        </CardContent>
      </Card>
    </form>
  );
};

export default NewCategory;
